module.exports = __webpack_public_path__ + "25a5407b51f3af7e1448ba751fcf8c49.fbx";